import withUser from 'components/withUser';
import LiveAgent from './LiveAgent';

export default withUser(LiveAgent);
